import { DifferenceType } from '@modules-deprecated/bankReconciliation/types'

export const getDifferenceType = (
  subjectsAmount: number,
  crossCurrencyPaymentAmount?: number,
  selectedDifferenceType?: DifferenceType,
): DifferenceType | undefined => {
  if (selectedDifferenceType) {
    return selectedDifferenceType
  }

  if (!crossCurrencyPaymentAmount || crossCurrencyPaymentAmount === subjectsAmount) {
    return undefined
  }

  return crossCurrencyPaymentAmount < subjectsAmount ? 'underpayment' : 'overpayment'
}
